import emailIcon from '../../assets/images/email.svg';
import mmsIcon from '../../assets/images/mms.svg';
import smsIcon from '../../assets/images/sms.svg';

const ICONS = {
  email: emailIcon,
  mms: mmsIcon,
  sms: smsIcon,
};

export function ChannelIcon({ channel, className }) {
  const key = String(channel || '')
    .trim()
    .toLowerCase();
  const src = ICONS[key];
  if (!src) return null;

  return <img className={className} src={src} alt="" aria-hidden />;
}
